import $ from 'jquery';
import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, listenForPrevBtnClick, listenForNextBtnClick, disablePrevNextBtns } from '../utils/PrevNextButtons.js';
import { resizeScroll } from '../core/ScrollService.js';
const initCarousels = () => {
    if (document.querySelectorAll('.pSection--carousel .carousel')) {
        document.querySelectorAll('.pSection--carousel .carousel').forEach((domElt) => {
            let domEmbla = domElt.querySelector('.embla');
            let domEmblaPrev = domElt.querySelector('.carousel_nav_prev');
            let domEmblaNext = domElt.querySelector('.carousel_nav_next');
            let loop = domEmbla.getAttribute('data-loop') && domEmbla.getAttribute('data-loop') === "true";
            let dragFree = domEmbla.getAttribute('data-dragfree') && domEmbla.getAttribute('data-dragfree') === "true";
            let domEmblaOptions = { align: "start", loop: loop, dragFree: dragFree, draggable: true, containScroll: 'trimSnaps' };
            let domEmblaPlugins = [];
            let embla = EmblaCarousel(domEmbla, domEmblaOptions, domEmblaPlugins);
            setupPrevNextBtns(domEmblaPrev, domEmblaNext, embla);

            embla.on("select", disablePrevNextBtns);
            embla.on("init", disablePrevNextBtns);
            embla.on("init", () => { resizeScroll(); });
        })
    }
};

export { initCarousels };
